import { THEMES } from '../types/themes'
import { FPS } from '../types/video'
import { DEFAULT_WORDS } from '../types/defaultSubtitles'
import { defaultClipScene } from '../types/defaultClipScene'
import type { TimelineDoc } from './types'

/** A small document for Remotion Studio's preview of the `timeline` composition. */
export const defaultTimelineDoc: TimelineDoc = {
  fps: FPS,
  compositionWidth: 1080,
  compositionHeight: 1920,
  theme: THEMES[0]!.config,
  tracks: [
    { id: 'overlay', items: ['title'], hidden: false, muted: false },
    { id: 'captions', items: ['captions'], hidden: false, muted: false },
    { id: 'background', items: ['bg'], hidden: false, muted: false },
    { id: 'scenes', items: ['media-1'], hidden: false, muted: false },
  ],
  items: {
    bg: {
      id: 'bg',
      type: 'solid',
      from: 0,
      durationInFrames: 30 * FPS,
      top: 0,
      left: 0,
      width: 1080,
      height: 1920,
      opacity: 1,
      isDraggingInTimeline: false,
      borderRadius: 0,
      rotation: 0,
      color: THEMES[0]!.config.colors.primary,
      keepAspectRatio: false,
      fadeInDurationInSeconds: 0,
      fadeOutDurationInSeconds: 0,
    },
    'media-1': {
      id: 'media-1',
      type: 'scene',
      from: 0,
      durationInFrames: 30 * FPS,
      top: 0,
      left: 0,
      width: 1080,
      height: 1920,
      opacity: 1,
      isDraggingInTimeline: false,
      audioStartFromInSeconds: 0,
      decibelAdjustment: 0,
      playbackRate: 1,
      audioFadeInDurationInSeconds: 0,
      audioFadeOutDurationInSeconds: 0,
      assetId: 'ass_demo',
      zealous: {
        source: { kind: 'recording', recordingId: 'rec_demo' },
        sourceEnd: 30,
      },
    },
    title: {
      id: 'title',
      type: 'component',
      componentId: 'title-card',
      props: {
        title: 'Timeline composition',
        subtitle: 'Remotion Studio preview',
      },
      from: 0,
      durationInFrames: 3 * FPS,
      top: 0,
      left: 0,
      width: 1080,
      height: 1920,
      opacity: 1,
      isDraggingInTimeline: false,
      rotation: 0,
      fadeInDurationInSeconds: 0,
      fadeOutDurationInSeconds: 0.5,
    },
    captions: {
      id: 'captions',
      type: 'captions',
      from: 0,
      durationInFrames: 30 * FPS,
      top: 1400,
      left: 60,
      width: 960,
      height: 220,
      opacity: 1,
      isDraggingInTimeline: false,
      rotation: 0,
      style: {
        color: '#ffffff',
        fontFamily: 'Red Hat Display',
        highlightColor: THEMES[0]!.config.colors.accent,
        highlightType: 'last-word',
        fontSize: 60,
        fontWeight: 700,
        linesPerPage: 2,
        lineHeight: 1.5,
        textAlign: 'center',
        scrollType: 'line-by-line',
      },
      zealous: { sceneId: 'media-1' },
    },
  },
  assets: {
    ass_demo: {
      id: 'ass_demo',
      type: 'audio',
      filename: 'demo.m4a',
      size: 0,
      remoteUrl: defaultClipScene.mediaUrl,
      remoteFileKey: null,
      mimeType: 'audio/mp4',
      durationInSeconds: 30,
    },
    'transcript:rec_demo': {
      id: 'transcript:rec_demo',
      type: 'transcript',
      recordingId: 'rec_demo',
      words: DEFAULT_WORDS,
    },
  },
}
